// extracted by mini-css-extract-plugin
module.exports = {"root":"Banner_root__qCW0O","close":"Banner_close__WS_ag"};